import { takeEvery } from 'redux-saga/effects';

import * as messagesPageActions from 'store/modules/messagesPage';
import { uploadFiles } from './utils';

export default function* listenUploadFiles() {
  yield takeEvery(messagesPageActions.uploadFiles.toString(), uploadFiles);
}
